// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader {
  position: fixed;
  background: transparent;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.7);
  z-index: 103;
}
.loader:before {
  display: inline-block;
  position: absolute;
  top: 0;
  left: 0;
  padding: 0 5px;
  content: attr(data-title);
  font-size: 0.75rem;
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  color: white;
  background-color: rgb(255, 25, 100);
  border-radius: 0.25rem 0 0.25rem 0;
}
.loader .loader-stage {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 2rem 0;
  margin: 0 -5%;
  overflow: hidden;
  width: 100%;
}
.loader .loader-stage .dot-typing {
  position: relative;
  left: -9999px;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background-color: var(--color-white);
  color: var(--color-white);
  box-shadow: 9968px 0 0 0 var(--color-white), 10000px 0 0 0 var(--color-white), 10032px 0 0 0 var(--color-white);
  animation: dotTyping 1.5s infinite linear;
}
@keyframes dotTyping {
  0% {
    box-shadow: 9968px 0 0 0 var(--color-white), 10000px 0 0 0 var(--color-white), 10032px 0 0 0 var(--color-white);
  }
  16.667% {
    box-shadow: 9968px -10px 0 0 var(--color-white), 10000px 0 0 0 var(--color-white), 10032px 0 0 0 var(--color-white);
  }
  33.333% {
    box-shadow: 9968px 0 0 0 var(--color-white), 10000px 0 0 0 var(--color-white), 10032px 0 0 0 var(--color-white);
  }
  50% {
    box-shadow: 9968px 0 0 0 var(--color-white), 10000px -10px 0 0 var(--color-white), 10032px 0 0 0 var(--color-white);
  }
  66.667% {
    box-shadow: 9968px 0 0 0 var(--color-white), 10000px 0 0 0 var(--color-white), 10032px 0 0 0 var(--color-white);
  }
  83.333% {
    box-shadow: 9968px 0 0 0 var(--color-white), 10000px 0 0 0 var(--color-white), 10032px -10px 0 0 var(--color-white);
  }
  100% {
    box-shadow: 9968px 0 0 0 var(--color-white), 10000px 0 0 0 var(--color-white), 10032px 0 0 0 var(--color-white);
  }
}
.loader .loader-stage .loader-text {
  text-align: center;
  width: 100%;
  padding: 32px 20px;
}
.loader .loader-stage .loader-text p {
  font-size: 20px;
}`, "",{"version":3,"sources":["webpack://./src/components/loader/Loader.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,uBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;AACJ;AAAI;EACI,qBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,iGAAA;EACA,YAAA;EACA,mCAAA;EACA,kCAAA;AAER;AAAI;EACI,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;AAER;AADQ;EACI,kBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,yBAAA;EACA,+GAAA;EACA,yCAAA;AAGZ;AADQ;EACI;IACI,+GAAA;EAGd;EADU;IACI,mHAAA;EAGd;EADU;IACI,+GAAA;EAGd;EADU;IACI,mHAAA;EAGd;EADU;IACI,+GAAA;EAGd;EADU;IACI,mHAAA;EAGd;EADU;IACI,+GAAA;EAGd;AACF;AADQ;EACI,kBAAA;EACA,WAAA;EACA,kBAAA;AAGZ;AAFY;EACI,eAAA;AAIhB","sourcesContent":[".loader{\n    position: fixed;\n    background: transparent;\n    top:0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: rgba( #000000, 0.7);\n    z-index: 103;\n    &:before {\n        display: inline-block;\n        position: absolute;\n        top: 0;\n        left: 0;\n        padding: 0 5px;\n        content: attr(data-title);\n        font-size: .75rem;\n        font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n        color: white;\n        background-color: rgb(255, 25, 100);\n        border-radius: .25rem 0 .25rem 0;\n    }\n    .loader-stage {\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: center;\n        align-items: center;\n        position: relative;\n        padding: 2rem 0;\n        margin: 0 -5%;\n        overflow: hidden;\n        width: 100%;\n        .dot-typing {\n            position: relative;\n            left: -9999px;\n            width: 25px;\n            height: 25px;\n            border-radius: 50%;\n            background-color: var(--color-white);\n            color: var(--color-white);\n            box-shadow: 9968px 0 0 0 var(--color-white), 10000px 0 0 0 var(--color-white), 10032px 0 0 0 var(--color-white);\n            animation: dotTyping 1.5s infinite linear;\n        }\n        @keyframes dotTyping {\n            0% {\n                box-shadow: 9968px 0 0 0 var(--color-white), 10000px 0 0 0 var(--color-white), 10032px 0 0 0 var(--color-white);\n            }\n            16.667% {\n                box-shadow: 9968px -10px 0 0 var(--color-white), 10000px 0 0 0 var(--color-white), 10032px 0 0 0 var(--color-white);\n            }\n            33.333% {\n                box-shadow: 9968px 0 0 0 var(--color-white), 10000px 0 0 0 var(--color-white), 10032px 0 0 0 var(--color-white);\n            }\n            50% {\n                box-shadow: 9968px 0 0 0 var(--color-white), 10000px -10px 0 0 var(--color-white), 10032px 0 0 0 var(--color-white);\n            }\n            66.667% {\n                box-shadow: 9968px 0 0 0 var(--color-white), 10000px 0 0 0 var(--color-white), 10032px 0 0 0 var(--color-white);\n            }\n            83.333% {\n                box-shadow: 9968px 0 0 0 var(--color-white), 10000px 0 0 0 var(--color-white), 10032px -10px 0 0 var(--color-white);\n            }\n            100% {\n                box-shadow: 9968px 0 0 0 var(--color-white), 10000px 0 0 0 var(--color-white), 10032px 0 0 0 var(--color-white);\n            }\n        }\n        .loader-text{\n            text-align: center;\n            width: 100%;\n            padding: 32px 20px;\n            p{\n                font-size: 20px;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
